export default __webpack_public_path__ + "static/media/TropicalGarden.a64b583a.ttf";